import styled from '@emotion/styled';
import { CloseIcon } from 'src/assets/icons/OldCloseIcon';
import { CheckIcon } from 'src/assets/icons/CheckIcon';
import { WatchIcon } from 'src/assets/icons/WatchIcon';
import { TrashIcon } from 'src/assets/icons/TrashIcon';
import { mainColors } from 'src/assets/colors';

export const ConfirmationContainer = styled('div', { label: 'ConfirmationContainer' })`
    display: flex;
    height: 80px;
    padding: 8px;
    position: relative;
`;

export const CheckIconWrapper = styled(CheckIcon, { label: 'CheckIconWrapper' })`
    fill: ${mainColors.main.primary};
    height: max-content;
    margin: 2px 0px;
    padding: 2px;
    width: 24px;
`;

export const TrashIconWrapper = styled(TrashIcon, { label: 'TrashIconWrapper' })`
    height: max-content;
    margin: 2px 0px;
    padding: 0 3px 0 4px;
    width: 24px;
`;

export const WatchIconWrapper = styled(WatchIcon, { label: 'WatchIconWrapper' })`
    height: max-content;
    width: 24px;
`;

export const TextContainer = styled('div', { label: 'TextContainer' })`
    flex: 1 1 auto;
    margin: 0 8px;
`;

export const TextHeader = styled('div', { label: 'TextHeader' })`
    font-size: 14px;
`;

export const TextDetails = styled('div', { label: 'TextDetails' })`
    font-size: 12px;
`;

export const CloseIconWrapper = styled(CloseIcon, { label: 'CloseIconWrapper' })`
    align-self: start;
    cursor: pointer;
    outline: none;
    width: 24px;
`;
